import React, { useEffect, useMemo } from 'react';
import type { Moment } from 'moment';
import moment from 'moment';
import type OrderItemStepTodo from '@this/src/domain/arrangement/order_item_step_todo';

interface Props {
  todo: OrderItemStepTodo;
}

const OrderItemStepDurationCounter: React.FC<Props> = ({ todo }) => {
  const { startedAt } = todo;

  if (!startedAt) {
    return null;
  }

  return (
    <div>
      <div>
        <span>経過時間: </span>
        <TimeElapsed startedAt={startedAt} />
      </div>
    </div>
  );
};

const TimeElapsed: React.FC<{ startedAt: Moment }> = ({ startedAt }) => {
  const [time, setTime] = React.useState(0);
  const formattedTime = useMemo(() => {
    const elapsedMinutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${elapsedMinutes}分${seconds < 10 ? `0${seconds}` : seconds}秒`;
  }, [time]);

  useEffect(() => {
    const interval = setInterval(() => {
      const now = moment();
      const duration = moment.duration(now.diff(startedAt));
      const seconds = Math.floor(duration.asSeconds());
      setTime(seconds);
    }, 1000);

    return () => clearInterval(interval);
  }, [startedAt]);

  return <span>{formattedTime}</span>;
};

export default OrderItemStepDurationCounter;
